import { ClienteAnaliseMercadoLancamentoMes } from './cliente-analise-mercado-lancamento-mes';

export class ClienteAnaliseMercadoLancamentoMesSave {
    id: number;
    mes: number;

    // Quantidade Potencial
    quantidadePotencial: number;
    // Peso Potencial
    pesoPotencial: number;
    // Valor Potencial
    valorPotencial: number;

    // Quantidade Pretendida
    quantidadePretendida: number;
    // Peso Pretendido
    pesoPretendido: number;
    // Valor Pretendido
    valorPretendido: number;
    // valorPretendidoPerc: number;

    // Quantidade Projetada
    quantidadeProjetada: number;
    // Peso Projetado
    pesoProjetado: number;
    // Valor Projetado
    valorProjetado: number;

    constructor(entity: ClienteAnaliseMercadoLancamentoMes) {
        if (!entity) {
            return;
        }

        this.id = entity.id;
        this.mes = entity.mes;

        // Quantidade Potencial
        this.quantidadePotencial = entity.quantidadePotencial;
        // Peso Potencial
        this.pesoPotencial = entity.pesoPotencial;
        // Valor Potencial
        this.valorPotencial = entity.valorPotencial;

        // Quantidade Pretendida
        this.quantidadePretendida = entity.quantidadePretendida;
        // Peso Pretendido
        this.pesoPretendido = entity.pesoPretendido;
        // Valor Pretendido
        this.valorPretendido = entity.valorPretendido;

        // Peso Projetado
        this.quantidadeProjetada = entity.quantidadeProjetada;
        // Peso Projetado
        this.pesoProjetado = entity.pesoProjetado;
        // Valor Projetado
        this.valorProjetado = entity.valorProjetado;
    }
}
